module.exports = __webpack_public_path__ + "static/pruefen-5d503cae65a54ca90b9672fc0a129c22.jpg";